import * as Types from 'src/actions/modal';
import { ClearModals, CloseModal, OpenModal } from 'src/actions/modal';

export interface ActiveModalsState {
  modalContent?: JSX.Element;
  modalHistory: JSX.Element[];
  className?: string;
  classNameHistory: (string | undefined)[];
}

const initialState: ActiveModalsState = {
  modalContent: undefined,
  modalHistory: [],
  classNameHistory: []
};

export function ActiveModalsReducer(
  state: ActiveModalsState = initialState,
  action: OpenModal | CloseModal | ClearModals
): ActiveModalsState {

  let modalHistory = state.modalHistory;
  let modalContent = undefined;
  let classNameContent = undefined;
  let classNameHistory = state.classNameHistory;

  switch (action.type) {
    case Types.CLOSE_MODAL:
      modalHistory.pop();
      if (modalHistory.length > 0) {
        modalContent = modalHistory[modalHistory.length - 1];
      } else {
        modalContent = undefined;
      }

      classNameHistory.pop();
      if (classNameHistory.length > 0) {
        classNameContent = classNameHistory[classNameHistory.length - 1];
      }  else {
        classNameContent = undefined;
      }

      return {
        modalContent: modalContent,
        modalHistory: modalHistory,
        className: classNameContent,
        classNameHistory: classNameHistory,
      };
    case Types.OPEN_MODAL:
      if (action.payload.modal !== state.modalContent) {
        modalHistory.push(action.payload.modal);
        classNameHistory.push(action.payload.className);
      }

      return {
        modalContent: action.payload.modal,
        modalHistory: modalHistory,
        className: action.payload.className,
        classNameHistory: classNameHistory,
      };
    case Types.CLEAR_MODAL:
      return {
        modalContent: undefined,
        modalHistory: [], 
        className: undefined,
        classNameHistory: [], 
    };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal/ActiveModalsReducer.tsx